import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatDialogModule } from '@angular/material/dialog';

// Autres modules externes utilises 

// Modules metiers utilises
import { AntenneModule } from '../structure/antenne/antenne.module';
import { ParcModule } from '../structure/parc/parc.module';
import { SousParcModule } from '../structure/sous-parc/sous-parc.module';
import { StaticTypesModule } from '../../static-types/static-types.module';
import { UserModule } from '../humain/user/user.module';

// Modules communs utilises
import { FilterableSelectModule } from '../../shared/filterable-select/filterable-select.module';
import { PannelModule } from '../../shared/pannel/pannel.module';

// Composants metiers
import { ParametagePerimetresComponent } from './components/parametrage-perimetres.component';
import { PerimetreComponent } from './components/perimetre.component';
import { PerimetreSelectorComponent } from './components/perimetre-selector.component';
import { PerimetreUtilisateurButtonComponent } from './components/perimetre-utilisateur-button.component';
import { PerimetreUtilisateurDialogComponent } from './components/perimetre-utilisateur-dialog.component';

// Services metier
import { PerimetresService } from './services/perimetres.service';

// Bridges avec la partie anguler
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,

		MatDialogModule,
		
		FilterableSelectModule,
		PannelModule,
		
		AntenneModule,
		ParcModule,
		SousParcModule,
		StaticTypesModule,
		UserModule,
	],
	providers: [
		PerimetresService,
	],
	declarations: [
		ParametagePerimetresComponent,
		PerimetreComponent,
		PerimetreSelectorComponent,
		PerimetreUtilisateurButtonComponent,
		PerimetreUtilisateurDialogComponent,
	],
	exports: [
		ParametagePerimetresComponent,
		PerimetreUtilisateurButtonComponent,
	]
})
export class PerimetresModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
	.directive('perimetreUtilisateurButton',
		downgradeComponent({ component: PerimetreUtilisateurButtonComponent })
	) //
;